/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryManagerConfiguration
 */
export interface AncillaryManagerConfiguration {
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof AncillaryManagerConfiguration
     */
    readonly ancillaryCategories?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof AncillaryManagerConfiguration
     */
    readonly ancillaries?: Array<GuidIdAndLabel> | null;
}

export function AncillaryManagerConfigurationFromJSON(json: any): AncillaryManagerConfiguration {
    return AncillaryManagerConfigurationFromJSONTyped(json, false);
}

export function AncillaryManagerConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryManagerConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ancillaryCategories': !exists(json, 'ancillaryCategories') ? undefined : (json['ancillaryCategories'] === null ? null : (json['ancillaryCategories'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'ancillaries': !exists(json, 'ancillaries') ? undefined : (json['ancillaries'] === null ? null : (json['ancillaries'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function AncillaryManagerConfigurationToJSON(value?: AncillaryManagerConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


